import { axiosInstance } from '../../../common/api';

export const getProfile = () => ({ type: 'GET_PROFILE', payload: axiosInstance.get('auth') });

export const updateProfile = (data) => ({ type: 'UPDATE_PROFILE', payload: axiosInstance.put('auth', data) });
